/**
 * Translate description: Table component
 */

import { Fragment, useContext } from 'react';

import { useLanguageContext } from "../../../context/LanguageContext";
import AppContext from '../../../context/AppContext';

import Filter from '../../../components/filter/Filter';
import FilterSourceLang from '../../../components/filter/FilterSourceLang';
import FilterTranslated from '../../../components/filter/FilterTranslated';
import FilterStatus from '../../../components/filter/FilterStatus';

import {
  ContentTable, ContentHeader, ContentHeaderItem, ContentBody,
  ContentBodyCheckbox, ContentBodyItem,
  ContentBodyItemImage, ContentBodyItemStatus, ContentBodyItemPublished,
  ContentBodyItemTranslations, ContentBodyItemEdit
} from '../../../components/blocks/ContentTable';

import { ContentList, ContentListRow, ContentListItem } from '../../../components/blocks/ContentList';

export default function Content() {
  const { t } = useLanguageContext();
  const { listItems } = useContext(AppContext);
  const { loading } = useContext(AppContext);

  return (
    <Fragment>
      <Filter>
        <FilterSourceLang />
        <FilterTranslated />
        <FilterStatus />
      </Filter>

      <ContentTable>
        <ContentHeader>
          <ContentHeaderItem title={t('ID')} sortBy="id" width={50} />
          <ContentHeaderItem title={t('Image')} width={100} />
          <ContentHeaderItem title={t('Name')} sortBy="name" />
          <ContentHeaderItem title={t('Translations')} width={120} />
          <ContentHeaderItem title={t('Views')} width={50} />
          <ContentHeaderItem title={t('Creator')} width={100} />
          <ContentHeaderItem title={t('Author')} width={100} />
          <ContentHeaderItem title={t('Published at')} sortBy="published_at" width={100} />
          <ContentHeaderItem title={t('Status')} width={100} />
          <ContentHeaderItem width={100}></ContentHeaderItem>
        </ContentHeader>

        <ContentBody colspan={11}>
          {(Array.isArray(listItems) && !loading && listItems?.length) ? (
            listItems.map((row) => (
              <tr key={row.id}>
                <ContentBodyCheckbox row={row} />
                <ContentBodyItem>{row.id}</ContentBodyItem>
                <ContentBodyItemImage image={row.image} />
                <ContentBodyItem to={`/news/${row.id}`}>{row.name}</ContentBodyItem>
                <ContentBodyItemTranslations row={row} editLink="news" />
                <ContentBodyItem>{row.views}</ContentBodyItem>
                <ContentBodyItem>{row.creator?.name ?? row.creator?.login ?? ''}</ContentBodyItem>
                <ContentBodyItem>{row.author?.name ?? row.author?.login ?? ''}</ContentBodyItem>
                <ContentBodyItemPublished row={row} />
                <ContentBodyItemStatus row={row} />
                <ContentBodyItemEdit row={row} addLink='news' editLink='news' deleteLink='news' disableCreate={true}/>
              </tr>
            ))
          ) : null}
        </ContentBody>
      </ContentTable>

      <ContentList>
        {(Array.isArray(listItems) && !loading && listItems?.length) ? (
          listItems.map((row) => (
            <ContentListRow key={row.id} row={row} editLink={'news'} deleteLink={'news'}>
              <ContentListItem>{row.name}</ContentListItem>
              <ContentListItem>{row.slug}</ContentListItem>
            </ContentListRow>
          ))
        ) : null}
      </ContentList>

    </Fragment >
  );
}